<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">
      {{
        CompanyOfficeForm && CompanyOfficeForm.controls.id.value !== null
          ? 'Edit office'
          : 'Add office'
      }}
    </h3>
    <p class="modal-subtitle mb-0">
      A client office location that vendors can be assigned to.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  @if (CompanyOfficeForm) {
    <form [formGroup]="CompanyOfficeForm">
      <div class="form-group">
        <label for="officeName" class="form-label" requiredAsterisk>
          Office name
        </label>
        <input
          id="officeName"
          type="text"
          class="form-control"
          formControlName="officeName"
          placeholder="What this office is called internally"
        />
      </div>

      <hr class="asr-divider" />

      <div formGroupName="StreetAddress" class="row g-3">
        <div class="col-md-6">
          <div class="form-group mb-0">
            <label for="address1" class="form-label" requiredAsterisk>
              Street address
            </label>
            <input
              id="address1"
              type="text"
              class="form-control"
              formControlName="address1"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-0">
            <label for="address2" class="form-label"> Street address 2 </label>
            <input
              id="address2"
              type="text"
              class="form-control"
              formControlName="address2"
            />
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group mb-0">
            <label for="city" class="form-label" requiredAsterisk> City </label>
            <input
              id="city"
              type="text"
              class="form-control"
              formControlName="city"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group mb-0">
            <label for="state" class="form-label" requiredAsterisk>
              {{
                LocalizationInfo && LocalizationInfo.territory
                  ? LocalizationInfo.territory.label
                  : 'State'
              }}
            </label>
            <select class="form-select" id="state" formControlName="state">
              @for (
                SubNationalDivision of SubNationalDivisions;
                track SubNationalDivision
              ) {
                <option [ngValue]="SubNationalDivision.abbreviation">
                  {{ SubNationalDivision.name }}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group mb-0">
            <label for="zip" class="form-label" requiredAsterisk>
              {{
                LocalizationInfo && LocalizationInfo.postalCode
                  ? LocalizationInfo.postalCode.label
                  : 'Zip'
              }}
            </label>
            <input
              type="text"
              class="form-control"
              id="zip"
              placeholder="{{
                LocalizationInfo && LocalizationInfo.postalCode.format
                  ? LocalizationInfo.postalCode.format
                  : ''
              }}"
              [inputMask]="zipMask"
              formControlName="zip"
            />
          </div>
        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      Save office
    </button>
  </div>
</div>
